import React from 'react';
import { Route } from "react-router-dom";
import { SecureRoute } from '@okta/okta-react';
import settings from '../../../settings';

export const CerebroRoute = props => settings.OKTA_ENABLED ? <SecureRoute {...props} /> : <Route {...props} />;
